import axios from "axios";
import { AuthInfoModel, PreAccessTokenModel } from "models";
import { IAPIResult } from "models/interfaces";

export async function preAccessToken(mail: string) {
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/entry/pre-access-token/create",
    { pre_mail_address: mail }
  );

  return response.data;
}

export async function preAccessTokenCheck(token: string) {
  const response = await axios.post<IAPIResult<PreAccessTokenModel>>(
    "/api.d/v1/entry/pre-access-token/search",
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
}

export async function detail() {
  const response = await axios.get<IAPIResult<AuthInfoModel>>(
    "/api.d/v1/auth/login-token/detail"
  );

  if (response.data && response.data.data) {
    localStorage.setItem("corp", response.data.data.corp_id);
  }

  return response.data;
}
